/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BusinessAddressDto } from './BusinessAddressDto';
import {
    BusinessAddressDtoFromJSON,
    BusinessAddressDtoFromJSONTyped,
    BusinessAddressDtoToJSON,
    BusinessAddressDtoToJSONTyped,
} from './BusinessAddressDto';
import type { PrimaryContactDto } from './PrimaryContactDto';
import {
    PrimaryContactDtoFromJSON,
    PrimaryContactDtoFromJSONTyped,
    PrimaryContactDtoToJSON,
    PrimaryContactDtoToJSONTyped,
} from './PrimaryContactDto';

/**
 * Customer creation data
 * @export
 * @interface CreateCustomerRequest
 */
export interface CreateCustomerRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequest
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequest
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequest
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequest
     */
    industryType?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequest
     */
    companySize?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequest
     */
    timezone?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequest
     */
    language?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequest
     */
    currency?: string;
    /**
     * 
     * @type {PrimaryContactDto}
     * @memberof CreateCustomerRequest
     */
    primaryContact?: PrimaryContactDto;
    /**
     * 
     * @type {BusinessAddressDto}
     * @memberof CreateCustomerRequest
     */
    businessAddress?: BusinessAddressDto;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CreateCustomerRequest
     */
    settings?: { [key: string]: any; };
}

/**
 * Check if a given object implements the CreateCustomerRequest interface.
 */
export function instanceOfCreateCustomerRequest(value: object): value is CreateCustomerRequest {
    return true;
}

export function CreateCustomerRequestFromJSON(json: any): CreateCustomerRequest {
    return CreateCustomerRequestFromJSONTyped(json, false);
}

export function CreateCustomerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCustomerRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'companyName': json['company_name'] == null ? undefined : json['company_name'],
        'displayName': json['display_name'] == null ? undefined : json['display_name'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'industryType': json['industry_type'] == null ? undefined : json['industry_type'],
        'companySize': json['company_size'] == null ? undefined : json['company_size'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
        'language': json['language'] == null ? undefined : json['language'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'primaryContact': json['primary_contact'] == null ? undefined : PrimaryContactDtoFromJSON(json['primary_contact']),
        'businessAddress': json['business_address'] == null ? undefined : BusinessAddressDtoFromJSON(json['business_address']),
        'settings': json['settings'] == null ? undefined : json['settings'],
    };
}

export function CreateCustomerRequestToJSON(json: any): CreateCustomerRequest {
    return CreateCustomerRequestToJSONTyped(json, false);
}

export function CreateCustomerRequestToJSONTyped(value?: CreateCustomerRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_name': value['companyName'],
        'display_name': value['displayName'],
        'email': value['email'],
        'phone': value['phone'],
        'industry_type': value['industryType'],
        'company_size': value['companySize'],
        'timezone': value['timezone'],
        'language': value['language'],
        'currency': value['currency'],
        'primary_contact': PrimaryContactDtoToJSON(value['primaryContact']),
        'business_address': BusinessAddressDtoToJSON(value['businessAddress']),
        'settings': value['settings'],
    };
}

